window.URL_GIS = ''
window.URL_RADIS = ''
window.URL_SADIS = ''
window.URL_ADMIN = ''
window.URL_API = '/srv/'
